import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/sponsor',
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    }
  })
}

export function getListUnread () {
  return request({
    url: '/sponsor_unread',
    method: 'get',
  })
}